angular.module('app.financeiro').factory('remessaPagamentoDetalheFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {

    var _apiName = 'RemessaPagamentoDetalhe';

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _save = function (isNew, dto) {
        var method = isNew ? 'Insert' : 'Save';
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/' + method, dto);
    };

    var _listaInfoAux = function (options, codigo) {
        var dto = options.data;
        dto.parms = [];
        dto.parms.push({ "name": "Codigo", "value": codigo });
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListaInfoAux', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _listRemessaPagamentoDetalhe = function (options, codigo) {
        var dto = options.data;
        dto.parms = [];
        dto.parms.push({ "name": "Codigo", "value": codigo });
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListRemessaPagamentoDetalhe', dto).then(
            function (response) {
                options.success(response.data);
            }, function (response) {
                var erro = {};
                erro.data = response.data;
                errorService.processError(erro, options);
            });
    };

    var _listRemessaPagamentoProposta = function (options, codigo) {
        var dto = options.data;
        dto.parms = [];
        dto.parms.push({ "name": "Codigo", "value": codigo });
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListRemessaPagamentoProposta', dto).then(
            function (response) {
                options.success(response.data);
            }, function (response) {
                var erro = {};
                erro.data = response.data;
                errorService.processError(erro, options);
            });
    };

    var factory = {};

    factory.findRecord = _findRecord;
    factory.save = _save;
    factory.listaInfoAux = _listaInfoAux;
    factory.ListRemessaPagamentoDetalhe = _listRemessaPagamentoDetalhe;
    factory.ListRemessaPagamentoProposta = _listRemessaPagamentoProposta;

    return factory;

}]);
